<template>
  <div class="home"
    :style="{ 
      cursor: 'url(' + pointerCursor + '), auto',
      margin: 0
      }">
    <nav class="navbar navbar-expand-md fixed-top">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item nav-main mr-0">
              <div class="nav-link">Misalignments</div> 
          </li>
        </ul>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item nav-secondary">
            <router-link to="/about" class="nav-link title-font">About</router-link>
          </li>
        </ul>
    </nav>   
    <BackgroundImage name="Home" :galleries="galleries" :showLabels="this.showLabels"/> 
    <DetailViewer :items="items" :scaling="scaling" :imgSize="imgSize" :isVisible="this.showLabels"/>
    
    <transition name="fade">
      <div 
        class="container-fluid align-items-center p-0 m-0 fade-text"
        v-if="fadeFullscreenText"
        :style="{ 
          pointerEvents: 'none',
          top: 0,
          left: 0,
          transitionDelay: '2s',
          position: 'absolute',
          width: '100vw',
          height: '100vh',
          margin: 0
        }"
      >
        <div class="row align-items-center justify-content-center p-0"
          :style="{ 
            width: '100vw',
            height: '100vh',
            margin: 0
          }"
        >
          <div class="col-md-4 p-0">
            <h2>Press 'F11' in Windows or 'Command-Shift-F' in Mac for a full experience.</h2>
          </div>
        </div>
      </div>
    </transition>
    <!-- <footer class="footer" style="width: 100%;">
        <div class="row justify-content-between m-3 fixed-bottom">
            <div class="col text-left align-self-end">
                <h2 style="font-size: 4vh;">A virtual exhibition by <br>Dalma Földesi & Jung In Seo</h2>
            </div>
            <div class="col text-right align-self-end">
              <h2 class="title-font" style="font-size: 2.5vh;">Presented by the <br>
                  <a href="https://arts.mit.edu/start/wiesner-student-art-gallery/" class="art-link">
                    Wiesner Student Art Gallery
                  </a>
                  </h2>
            </div>
        </div>
    </footer> -->
  </div>
</template>

<script>
// @ is an alias to /src
import DetailViewer from "@/components/DetailViewer.vue";
import BackgroundImage from "@/components/BackgroundImage.vue";
import json from "@/assets/json/galleries.json";

export default {
  name: "Home",
  props: ["galleries"],
  components: {
    DetailViewer,
    BackgroundImage
  },
  data: function() {
    return {
      name: "Home",
      showLabels: false,
      pointerCursor: require('@/assets/cursors/magnify.svg'),
      clickCursor: require('@/assets/cursors/pointer.svg'),
      fadeFullscreenText: window.fadeFullscreenText
    };
  },
  beforeRouteEnter(to, from, next) {
    let img = new Image();
    img.src = require("@/assets/galleries/" + json["galleries"]["MachineRoom"][0]["image"]);
    setTimeout(function() {
      next();
    }, 250);
  },
  methods: {
    setLabelsVisible(bVisible) {
      this.showLabels = bVisible;
    },
  },
  computed: {
    imgSize: function() {
      return this.galleries["galleries"][this.name][0]["imageSize"];
    },
    items: function() {
       return this.galleries["galleries"][this.name][0]["items"];
    },
  },
  created() {
    this.scaling = [(this.imgSize[0] * (window.innerHeight/this.imgSize[1]))/this.imgSize[0], window.innerHeight/this.imgSize[1]];
  },
  mounted() {
    if (!window.visited) {
      this.fadeFullscreenText = true;
    }
    else {
      this.fadeFullscreenText = false;
    }
    window.visited = true;
  },
  destroyed() {
  }
};
</script>

<style scoped>

.art-link {
  color: white;
}

.a:active{
  color: white;
}

a.nav-link.router-link-exact-active.router-link-active {
  color: white;
}

a.nav-link.title-font {
  color: white;
}


.art-link:hover {
  font-weight: 800;
  text-decoration: none;
  cursor: url('../assets/cursors/pointer.svg'), auto;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.fade-text {
  opacity:0;
}

.fade-enter {
  opacity: 1.0;
}
.fade-enter-active {
  transition: opacity 2s;
}
.fade-enter-to {
  opacity: 0.0;
}
.fade-leave {
  opacity: 0.0;
}
.fade-leave-active {
  transition: opacity 2s;
}
.fade-leave-to {
  opacity: 0.0;
}



</style>


